import { useState } from "react";
import ToolBar from "../../Componant/ToolBar";
import { Form, Table, Badge } from "react-bootstrap";
import UseToggle from "../../../Hooks/UseToggle";
import UserList from "./UserList";
import { userServices } from "../../../APIServices/UserData/userServices";
import { useEffect } from "react";
import Moment from "react-moment";

const UserManagementData = ({ organizationList }) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [members, setMembers] = useState([]);
  const [memberData, setMemberData] = useState("");
  const [memberCount, setMemberCount] = useState(0);
  const [memberIds, setMemberIds] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [hoverId, setHoverId] = useState(null);

  const toggleSingle = (id) => {
    setMemberIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (memberIds.length === members.length) {
      setMemberIds([]);
    } else {
      setMemberIds(members.map((c) => c.userId));
    }
  };

  const isAllChecked =
    members.length > 0 && memberIds.length === members.length;
  const isChecked = (id) => memberIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(memberCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, memberCount);

  const getMembers = async () => {
    setLoader(true);
    let data = await userServices.getMembers(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setMembers(data?.data || []);
    setMemberCount(data?.count || 0);
    setLoader(false);
  };

  useEffect(() => {
    getMembers();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
        <ToolBar
          toggles={toggles}
          search={search}
          setSearch={setSearch}
          checkedIds={memberIds}
          setCheckedIds={setMemberIds}
          start={start}
          end={end}
          totalItems={memberCount}
          page={pageNumber}
          setSelected={setMemberData}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          setPage={setPageNumber}
          setPageSize={setItemsPerPage}
          pageSize={itemsPerPage}
          totalPages={totalPages}
          // deleteData={deleteMember}
          editField
        />
        <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
          <div
            className={`table-section overflow-auto bg-white ${
              showPreview ? "border-end" : ""
            }`}
            style={{ height: "calc(100vh - 169px)" }}
          >
            <Table
              hover
              className="contacts-table mb-0"
              style={{ verticalAlign: "middle" }}
            >
              <thead>
                <tr>
                  <th>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isAllChecked}
                          onChange={toggleAll}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>User</div>
                    </div>
                  </th>
                  {!memberData && (
                    <>
                      <th>Phone</th>
                      <th>Designation</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Joining Date | Time</th>
                      <th>Update Date | Time</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {members?.map((item) => (
                  <tr
                    key={item.userId}
                    className={`contact-row ${
                      memberData?.userId === item.userId ? "active" : ""
                    }`}
                    onClick={() => {
                      setMemberData(item);
                      setShowPreview(true);
                    }}
                  >
                    <td>
                      <div
                        className="d-flex align-items-center gap-2"
                        onMouseEnter={() => setHoverId(item.userId)}
                        onMouseLeave={() => setHoverId(null)}
                      >
                        <div className="avatar-sm">
                          {hoverId === item.userId || isChecked(item.userId) ? (
                            <Form.Check
                              type="checkbox"
                              checked={isChecked(item.userId)}
                              onChange={() => toggleSingle(item.userId)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          ) : (
                            item.name.charAt(0)
                          )}
                        </div>
                        <div>
                          <div className="fw-medium">{item.name}</div>
                          <small className="text-muted">{item.email}</small>
                        </div>
                      </div>
                    </td>
                    {!memberData && (
                      <>
                        <td>{item.phone || "NA"}</td>
                        <td className="text-capitalize">{item?.designation}</td>
                        <td>Member</td>
                        <td className="w-auto">
                          <Badge
                            pill
                            bg="transparent"
                            className={`tag-pill text-capitalize text-${item?.status === "active" ? "success" : "danger"}`}
                            style={{
                              border: `1px solid var(--${item?.status === "active" ? "success" : "danger"})`,
                            }}
                          >
                            {item?.status === "active"
                              ? "Activated"
                              : "Deactivated"}
                          </Badge>
                        </td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.createdAt}
                          </Moment>
                        </td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.updatedAt}
                          </Moment>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className={`preview-section ${showPreview ? "open" : ""}`}>
            {memberData && (
              <div
                className="overflow-auto"
                style={{ height: "calc(100vh - 169px)" }}
              >
                <div className="preview-scroll p-0">
                  <div className="preview-block">
                    <UserList
                      userId={memberData?.userId}
                      getMembers={getMembers}
                      organizationList={organizationList}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default UserManagementData;
